export const invoicesTranslations = {
  // Invoices general
  "invoices": {
    en: "Invoices",
    fi: "Laskutus"
  },
  "invoices.createInvoice": {
    en: "Create Invoice",
    fi: "Luo lasku"
  },
  "invoices.createInvoiceButton": {
    en: "Create Invoice",
    fi: "Muodosta lasku"
  },
  "invoices.invoiceCreation": {
    en: "Invoice Creation",
    fi: "Laskutusaineiston luonti"
  },
  "invoices.step": {
    en: "Step",
    fi: "Vaihe"
  },
  "invoices.selectProjectOrSubproject": {
    en: "Select project or subproject",
    fi: "Valitse projekti tai osaprojekti"
  },
  "invoices.search": {
    en: "Search by customer, project or subproject name...",
    fi: "Etsi asiakkaan, projektin tai osaprojektin nimellä..."
  },
  "invoices.noProjects": {
    en: "No projects",
    fi: "Ei projekteja"
  },
  "invoices.noSearchResults": {
    en: "No search results for",
    fi: "Ei hakutuloksia haulle"
  },
  "invoices.unbilledTransactions": {
    en: "unbilled transactions",
    fi: "laskuttamatonta tapahtumaa"
  },
  "invoices.project": {
    en: "Project",
    fi: "Projekti"
  },
  "invoices.subproject": {
    en: "Subproject",
    fi: "Osaprojekti"
  },
  "invoices.customer": {
    en: "Customer",
    fi: "Asiakas"
  },
  "invoices.attachments": {
    en: "Attachments",
    fi: "Liitteet"
  },
  "invoices.addTimeEntryAttachment": {
    en: "Add time entry attachment",
    fi: "Lisää tuntikirjausliite"
  },
  "invoices.noAttachments": {
    en: "No attachments",
    fi: "Ei liitteitä"
  },
  "invoices.downloadAttachment": {
    en: "Download attachment",
    fi: "Lataa liite"
  },
  "invoices.downloadError": {
    en: "Failed to download attachment",
    fi: "Liitteen lataus epäonnistui"
  },
  "invoices.invoiced": {
    en: "Invoiced",
    fi: "Laskutettu"
  },
  "invoices.notInvoiced": {
    en: "Not Invoiced",
    fi: "Laskuttamatta"
  },
  "invoices.withInvoices": {
    en: "Ready for Invoicing",
    fi: "Laskutusvalmiit"
  },
  "invoices.withoutInvoices": {
    en: "Without Invoices",
    fi: "Laskuttamattomat"
  },
  "invoices.moved": {
    en: "Invoiced",
    fi: "Laskutukseen siirretyt"
  },
  "invoices.all": {
    en: "All",
    fi: "Kaikki"
  },
  "invoices.filterProjects": {
    en: "Filter Projects",
    fi: "Suodata projektit"
  },
  "invoices.showAllProjects": {
    en: "Show all projects",
    fi: "Näytä kaikki projektit"
  },
  "invoices.showProjectsWithInvoices": {
    en: "Show projects ready for invoicing",
    fi: "Näytä laskutusvalmiit projektit"
  },
  "invoices.showProjectsWithoutInvoices": {
    en: "Show projects without invoices",
    fi: "Näytä laskuttamattomat projektit"
  },
  "invoices.loading": {
    en: "Loading...",
    fi: "Ladataan..."
  },
  "invoices.error": {
    en: "Error",
    fi: "Virhe"
  },
  "invoices.failedToLoadProjects": {
    en: "Failed to load projects",
    fi: "Projektien lataaminen epäonnistui"
  },
  "invoices.timeEntries": {
    en: "Time Entries",
    fi: "Tuntikirjaukset"
  },
  "invoices.invoiceInfo": {
    en: "Invoice Information",
    fi: "Laskun tiedot"
  },
  "invoices.back": {
    en: "Back",
    fi: "Takaisin"
  },
  "invoices.next": {
    en: "Next",
    fi: "Seuraava"
  },
  "invoices.complete": {
    en: "Complete",
    fi: "Valmis"
  },
  "invoices.cancel": {
    en: "Cancel",
    fi: "Peruuta"
  },
  "invoices.save": {
    en: "Save",
    fi: "Tallenna"
  },
  "invoices.invoiceCreated": {
    en: "Invoice created",
    fi: "Lasku luotu"
  },
  "invoices.invoiceCreatedSuccessfully": {
    en: "Invoice has been created successfully",
    fi: "Laskutusaineisto on luotu onnistuneesti"
  },
  "invoices.dateRange": {
    en: "Date Range",
    fi: "Aikaväli"
  },
  "invoices.startDate": {
    en: "Start Date",
    fi: "Alkupäivä"
  },
  "invoices.endDate": {
    en: "End Date",
    fi: "Loppupäivä"
  },
  "invoices.noExpert": {
    en: "No Expert",
    fi: "Ei asiantuntijaa"
  },
  "invoices.expert": {
    en: "expert",
    fi: "asiantuntija"
  },
  "invoices.experts": {
    en: "experts",
    fi: "asiantuntijaa"
  },
  "invoices.noSubproject": {
    en: "No Subproject",
    fi: "Ei osaprojektia"
  },
  "invoices.entries": {
    en: "entries",
    fi: "kirjausta"
  },
  "invoices.hideEntries": {
    en: "Hide entries",
    fi: "Piilota kirjaukset"
  },
  "invoices.showEntries": {
    en: "Show entries",
    fi: "Näytä kirjaukset"
  },
  "invoices.date": {
    en: "Date",
    fi: "Päivämäärä"
  },
  "invoices.hours": {
    en: "Hours",
    fi: "Tunnit"
  },
  "invoices.role": {
    en: "Price Group",
    fi: "Hintaryhmä"
  },
  "invoices.pricePerHour": {
    en: "Price (€/h)",
    fi: "Hinta (€/h)"
  },
  "invoices.description": {
    en: "Description",
    fi: "Selite"
  },
  "invoices.task": {
    en: "Task",
    fi: "Tehtävä"
  },
  "invoices.jiraKey": {
    en: "Jira Key",
    fi: "Jira-tunnus"
  },
  "invoices.customerInformation": {
    en: "Customer Information",
    fi: "Asiakkaan tiedot"
  },
  "invoices.co": {
    en: "C/O",
    fi: "C/O"
  },
  "invoices.address": {
    en: "Address",
    fi: "Osoite"
  },
  "invoices.postalCode": {
    en: "Postal Code",
    fi: "Postinumero"
  },
  "invoices.city": {
    en: "City",
    fi: "Postitoimipaikka"
  },
  "invoices.country": {
    en: "Country",
    fi: "Maa"
  },
  "invoices.billingEmail": {
    en: "Billing Email",
    fi: "Laskutuksen sähköpostiosoite"
  },
  "invoices.businessId": {
    en: "Business ID",
    fi: "Asiakkaan y-tunnus"
  },
  "invoices.invoiceDetails": {
    en: "Invoice Details",
    fi: "Laskun lisätiedot"
  },
  "invoices.reference": {
    en: "Buyer Reference",
    fi: "Ostajan viitetunniste"
  },
  "invoices.contractNumber": {
    en: "Contract Number",
    fi: "Sopimusnumero"
  },
  "invoices.seller": {
    en: "Seller",
    fi: "Myyjä"
  },
  "invoices.selectSeller": {
    en: "Select seller",
    fi: "Valitse myyjä"
  },
  "invoices.language": {
    en: "Language",
    fi: "Kieli"
  },
  "invoices.invoiceName": {
    en: "Invoice Name",
    fi: "Laskun nimi"
  },
  "invoices.additionalText": {
    en: "Additional Text",
    fi: "Lisäteksti"
  },
  "invoices.invoiceDate": {
    en: "Invoice Date",
    fi: "Päivämäärä"
  },
  "invoices.dueDate": {
    en: "Due Date",
    fi: "Eräpäivä"
  },
  "invoices.deliveryStart": {
    en: "Delivery Start",
    fi: "Toimitusajan alku"
  },
  "invoices.deliveryEnd": {
    en: "Delivery End",
    fi: "Toimitusajan loppu"
  },
  "invoices.selectDate": {
    en: "Select date",
    fi: "Valitse päivämäärä"
  },
  "invoices.penaltyInterest": {
    en: "Penalty Interest",
    fi: "Viivästyskorko"
  },
  "invoices.complaintTime": {
    en: "Complaint Time (days)",
    fi: "Huomautusaika"
  },
  "invoices.paymentTerms": {
    en: "Payment Terms",
    fi: "Maksuehto"
  },
  "invoices.netDays": {
    en: "net days",
    fi: "päivää netto"
  },
  "invoices.invoiceRows": {
    en: "Invoice Rows",
    fi: "Laskurivit"
  },
  "invoices.groupBySubprojectAndExpert": {
    en: "Subproject and Expert",
    fi: "Osaprojekti ja asiantuntija"
  },
  "invoices.groupByExpert": {
    en: "Expert",
    fi: "Asiantuntija"
  },
  "invoices.groupBySubproject": {
    en: "Subproject",
    fi: "Osaprojekti"
  },
  "invoices.rowDescription": {
    en: "Description",
    fi: "Kuvaus"
  },
  "invoices.code": {
    en: "Code",
    fi: "Koodi"
  },
  "invoices.kpAccount": {
    en: "KP Account",
    fi: "KP-tili"
  },
  "invoices.vat": {
    en: "VAT",
    fi: "ALV"
  },
  "invoices.quantity": {
    en: "Quantity",
    fi: "Määrä"
  },
  "invoices.price": {
    en: "Price",
    fi: "Hinta"
  },
  "invoices.total": {
    en: "Total",
    fi: "Yhteensä"
  },
  "invoices.totalExclVat": {
    en: "Total (excl. VAT)",
    fi: "Yhteensä (alv 0%)"
  },
  "invoices.vatAmount": {
    en: "VAT",
    fi: "ALV"
  },
  "invoices.totalInclVat": {
    en: "Total (incl. VAT)",
    fi: "Yhteensä (sis. ALV)"
  },
  "invoices.existingAttachments": {
    en: "Existing Attachments",
    fi: "Nykyiset liitteet"
  },
  "invoices.newAttachments": {
    en: "New Attachments",
    fi: "Uudet liitteet"
  },
  "invoices.dropFilesHere": {
    en: "Drop files here or",
    fi: "Pudota tiedostot tähän tai"
  },
  "invoices.selectFiles": {
    en: "Select files",
    fi: "Valitse tiedostot"
  },
  "invoices.preview": {
    en: "Preview",
    fi: "Esikatselu"
  },
  "invoices.invoicePreview": {
    en: "Invoice Preview",
    fi: "Laskun esikatselu"
  },
  "invoices.invoice": {
    en: "INVOICE",
    fi: "LASKU"
  },
  "invoices.close": {
    en: "Close",
    fi: "Sulje"
  },
  "invoices.failedToLoadCustomer": {
    en: "Failed to load customer data",
    fi: "Asiakkaan tietojen lataaminen epäonnistui"
  },
  "invoices.failedToLoadExperts": {
    en: "Failed to load experts",
    fi: "Asiantuntijoiden lataaminen epäonnistui"
  },
  "invoices.viewInvoice": {
    en: "View invoice",
    fi: "Näytä lasku"
  },
  "invoices.failedToLoadInvoice": {
    en: "Failed to load invoice",
    fi: "Laskun lataaminen epäonnistui"
  },
  "invoices.invoiceNumber": {
    en: "Invoice Number",
    fi: "Laskunumero"
  },
  "invoices.noTimeEntries": {
    en: "No time entries",
    fi: "Ei tuntikirjauksia"
  },
  "invoices.noInvoiceRows": {
    en: "No invoice rows",
    fi: "Ei laskurivejä"
  },
  "invoices.days": {
    en: "days",
    fi: "päivää"
  },
  "invoices.missingFieldsTooltip": {
    en: "Please fill in all required fields",
    fi: "Täytä kaikki pakolliset kentät"
  },
  "invoices.missingTimeEntryFields": {
    en: "All time entries must have hours and unit price",
    fi: "Kaikilla tapahtumilla on oltava tunnit ja yksikköhinta"
  },
  "invoices.noTimeEntriesSelected": {
    en: "Select at least one time entry",
    fi: "Valitse vähintään yksi tapahtuma"
  },
  "invoices.missingInvoiceInfoFields": {
    en: "Required invoice fields are missing",
    fi: "Pakolliset laskun kentät puuttuvat"
  },
  "invoices.missingInvoiceRows": {
    en: "At least one invoice row is required",
    fi: "Vähintään yksi laskurivi vaaditaan"
  },
  "invoices.invalidInvoiceRows": {
    en: "All invoice rows must be complete",
    fi: "Kaikki laskurivit on täytettävä"
  },
  "invoices.deliveryPeriod": {
    en: "Delivery Period",
    fi: "Toimitusjakso"
  },
  "invoices.addRow": {
    en: "Add Row",
    fi: "Lisää rivi"
  },
  "invoices.deleteRow": {
    en: "Delete row",
    fi: "Poista rivi"
  },
  "invoices.customDescription": {
    en: "Row Description",
    fi: "Rivin kuvaus"
  },
  "invoices.edit": {
    en: "Edit",
    fi: "Muokkaa"
  },
  "invoices.fixedPrice": {
    en: "Fixed Price",
    fi: "Kiinteähintainen"
  },
  "invoices.invoiceUpdated": {
    en: "Invoice updated",
    fi: "Lasku päivitetty"
  },
  "invoices.invoiceUpdatedSuccessfully": {
    en: "Invoice has been updated successfully",
    fi: "Lasku on päivitetty onnistuneesti"
  },
  "invoices.sendToNetvisor": {
    en: "Send to Netvisor",
    fi: "Lähetä Netvisoriin"
  },
  "invoices.sendToNetvisorConfirmTitle": {
    en: "Send Invoice to Netvisor",
    fi: "Lähetä lasku Netvisoriin"
  },
  "invoices.sendToNetvisorConfirmDescription": {
    en: "Are you sure you want to send this invoice to Netvisor? This action cannot be undone.",
    fi: "Haluatko varmasti lähettää tämän laskun Netvisoriin? Tätä toimintoa ei voi peruuttaa."
  },
  "invoices.sending": {
    en: "Sending...",
    fi: "Lähetetään..."
  },
  "invoices.sentToNetvisor": {
    en: "Sent to Netvisor",
    fi: "Lähetetty Netvisoriin"
  },
  "invoices.sentToNetvisorSuccessfully": {
    en: "Invoice has been sent to Netvisor successfully",
    fi: "Lasku on lähetetty Netvisoriin onnistuneesti"
  },
  "invoices.failedToSendToNetvisor": {
    en: "Failed to send invoice to Netvisor",
    fi: "Laskun lähettäminen Netvisoriin epäonnistui"
  },
  "invoices.cancelInvoice": {
    en: "Cancel Invoice",
    fi: "Peruuta lasku"
  },
  "invoices.cancelInvoiceConfirmTitle": {
    en: "Cancel Invoice",
    fi: "Peruuta lasku"
  },
  "invoices.cancelInvoiceConfirmDescription": {
    en: "Are you sure you want to cancel this invoice? This action cannot be undone.",
    fi: "Haluatko varmasti peruuttaa tämän laskun? Tätä toimintoa ei voi peruuttaa."
  },
  "invoices.cancelling": {
    en: "Cancelling...",
    fi: "Peruutetaan..."
  },
  "invoices.invoiceCancelled": {
    en: "Invoice cancelled",
    fi: "Lasku peruutettu"
  },
  "invoices.invoiceCancelledSuccessfully": {
    en: "Invoice has been cancelled successfully",
    fi: "Lasku on peruutettu onnistuneesti"
  },
  "invoices.failedToCancelInvoice": {
    en: "Failed to cancel invoice",
    fi: "Laskun peruuttaminen epäonnistui"
  }
};
